"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUPPORTED_CURRENCIES = exports.CURRENCY_MAX_DECIMAL_PRECISION = exports.CURRENCY_LIST = exports.Currency = void 0;
var Currency;
(function (Currency) {
    Currency["AED"] = "AED";
    Currency["AFN"] = "AFN";
    Currency["ALL"] = "ALL";
    Currency["AMD"] = "AMD";
    Currency["ANG"] = "ANG";
    Currency["AOA"] = "AOA";
    Currency["ARS"] = "ARS";
    Currency["AUD"] = "AUD";
    Currency["AWG"] = "AWG";
    Currency["AZN"] = "AZN";
    Currency["BAM"] = "BAM";
    Currency["BBD"] = "BBD";
    Currency["BDT"] = "BDT";
    Currency["BGN"] = "BGN";
    Currency["BHD"] = "BHD";
    Currency["BIF"] = "BIF";
    Currency["BMD"] = "BMD";
    Currency["BND"] = "BND";
    Currency["BOB"] = "BOB";
    Currency["BRL"] = "BRL";
    Currency["BSD"] = "BSD";
    Currency["BTN"] = "BTN";
    Currency["BWP"] = "BWP";
    Currency["BYN"] = "BYN";
    Currency["BZD"] = "BZD";
    Currency["CAD"] = "CAD";
    Currency["CDF"] = "CDF";
    Currency["CHF"] = "CHF";
    Currency["CLP"] = "CLP";
    Currency["CNY"] = "CNY";
    Currency["COP"] = "COP";
    Currency["CRC"] = "CRC";
    Currency["CUC"] = "CUC";
    Currency["CUP"] = "CUP";
    Currency["CVE"] = "CVE";
    Currency["CZK"] = "CZK";
    Currency["DJF"] = "DJF";
    Currency["DKK"] = "DKK";
    Currency["DOP"] = "DOP";
    Currency["DZD"] = "DZD";
    Currency["EGP"] = "EGP";
    Currency["ERN"] = "ERN";
    Currency["ETB"] = "ETB";
    Currency["EUR"] = "EUR";
    Currency["FJD"] = "FJD";
    Currency["FKP"] = "FKP";
    Currency["GBP"] = "GBP";
    Currency["GEL"] = "GEL";
    Currency["GGP"] = "GGP";
    Currency["GHS"] = "GHS";
    Currency["GIP"] = "GIP";
    Currency["GMD"] = "GMD";
    Currency["GNF"] = "GNF";
    Currency["GTQ"] = "GTQ";
    Currency["GYD"] = "GYD";
    Currency["HKD"] = "HKD";
    Currency["HNL"] = "HNL";
    Currency["HRK"] = "HRK";
    Currency["HTG"] = "HTG";
    Currency["HUF"] = "HUF";
    Currency["IDR"] = "IDR";
    Currency["ILS"] = "ILS";
    Currency["IMP"] = "IMP";
    Currency["INR"] = "INR";
    Currency["IQD"] = "IQD";
    Currency["IRR"] = "IRR";
    Currency["ISK"] = "ISK";
    Currency["JEP"] = "JEP";
    Currency["JMD"] = "JMD";
    Currency["JOD"] = "JOD";
    Currency["JPY"] = "JPY";
    Currency["KES"] = "KES";
    Currency["KGS"] = "KGS";
    Currency["KHR"] = "KHR";
    Currency["KMF"] = "KMF";
    Currency["KPW"] = "KPW";
    Currency["KRW"] = "KRW";
    Currency["KWD"] = "KWD";
    Currency["KYD"] = "KYD";
    Currency["KZT"] = "KZT";
    Currency["LAK"] = "LAK";
    Currency["LBP"] = "LBP";
    Currency["LKR"] = "LKR";
    Currency["LRD"] = "LRD";
    Currency["LSL"] = "LSL";
    Currency["LYD"] = "LYD";
    Currency["MAD"] = "MAD";
    Currency["MDL"] = "MDL";
    Currency["MGA"] = "MGA";
    Currency["MKD"] = "MKD";
    Currency["MMK"] = "MMK";
    Currency["MNT"] = "MNT";
    Currency["MOP"] = "MOP";
    Currency["MRU"] = "MRU";
    Currency["MUR"] = "MUR";
    Currency["MVR"] = "MVR";
    Currency["MWK"] = "MWK";
    Currency["MXN"] = "MXN";
    Currency["MYR"] = "MYR";
    Currency["MZN"] = "MZN";
    Currency["NAD"] = "NAD";
    Currency["NGN"] = "NGN";
    Currency["NIO"] = "NIO";
    Currency["NOK"] = "NOK";
    Currency["NPR"] = "NPR";
    Currency["NZD"] = "NZD";
    Currency["OMR"] = "OMR";
    Currency["PAB"] = "PAB";
    Currency["PEN"] = "PEN";
    Currency["PGK"] = "PGK";
    Currency["PHP"] = "PHP";
    Currency["PKR"] = "PKR";
    Currency["PLN"] = "PLN";
    Currency["PYG"] = "PYG";
    Currency["QAR"] = "QAR";
    Currency["RON"] = "RON";
    Currency["RSD"] = "RSD";
    Currency["RUB"] = "RUB";
    Currency["RWF"] = "RWF";
    Currency["SAR"] = "SAR";
    Currency["SBD"] = "SBD";
    Currency["SCR"] = "SCR";
    Currency["SDG"] = "SDG";
    Currency["SEK"] = "SEK";
    Currency["SGD"] = "SGD";
    Currency["SHP"] = "SHP";
    Currency["SLL"] = "SLL";
    Currency["SOS"] = "SOS";
    Currency["SPL"] = "SPL";
    Currency["SRD"] = "SRD";
    Currency["STN"] = "STN";
    Currency["SVC"] = "SVC";
    Currency["SYP"] = "SYP";
    Currency["SZL"] = "SZL";
    Currency["THB"] = "THB";
    Currency["TJS"] = "TJS";
    Currency["TMT"] = "TMT";
    Currency["TND"] = "TND";
    Currency["TOP"] = "TOP";
    Currency["TRY"] = "TRY";
    Currency["TTD"] = "TTD";
    Currency["TVD"] = "TVD";
    Currency["TWD"] = "TWD";
    Currency["TZS"] = "TZS";
    Currency["UAH"] = "UAH";
    Currency["UGX"] = "UGX";
    Currency["USD"] = "USD";
    Currency["UYU"] = "UYU";
    Currency["UZS"] = "UZS";
    Currency["VEF"] = "VEF";
    Currency["VND"] = "VND";
    Currency["VUV"] = "VUV";
    Currency["WST"] = "WST";
    Currency["XAF"] = "XAF";
    Currency["XCD"] = "XCD";
    Currency["XDR"] = "XDR";
    Currency["XOF"] = "XOF";
    Currency["XPF"] = "XPF";
    Currency["YER"] = "YER";
    Currency["ZAR"] = "ZAR";
    Currency["ZMW"] = "ZMW";
    Currency["ZWD"] = "ZWD";
})(Currency = exports.Currency || (exports.Currency = {}));
exports.CURRENCY_LIST = new Set(Object.values(Currency));
/**
 * According to the ISO standard, currency precision can range from zero decimals to three decimals.
 * For example, USD amounts have two digits to the right of the decimal, and JPY have none.
 */
exports.CURRENCY_MAX_DECIMAL_PRECISION = 3;
(function (Currency) {
    function isCurrency(value) {
        return exports.CURRENCY_LIST.has(value);
    }
    Currency.isCurrency = isCurrency;
})(Currency = exports.Currency || (exports.Currency = {}));
exports.SUPPORTED_CURRENCIES = [
    Currency.EUR,
    Currency.USD,
    Currency.GBP,
    Currency.SEK,
    Currency.CHF,
    Currency.NOK
];
//# sourceMappingURL=Currency.js.map